export default __webpack_public_path__ + "static/media/nav-search-zoom.4cff636a.svg";